import { request } from './request'
import type { RoadmapComment } from './types'

export type AddCommentArgs = {
  postId: string
  body: string
  authorName: string | null
}

export const addComment = async ({
  postId,
  body,
  authorName,
}: AddCommentArgs): Promise<RoadmapComment> => {
  const data = await request<{ comment: RoadmapComment }>({
    path: `/api/posts/${postId}/comments`,
    method: 'POST',
    body: { body, authorName },
  })

  return data.comment
}
